import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { Amplify } from 'aws-amplify';
import outputs from '../amplify_outputs.json';
import { LoggingService } from './app/core/utils/logging.service';
import { inject } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import th from '@angular/common/locales/th';

import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart } from 'chart.js';
Chart.register(ChartDataLabels);
Chart.defaults.font.family = "'IBM Plex Sans Thai', sans-serif";
Chart.defaults.font.size = 12;

Amplify.configure(outputs);
registerLocaleData(th);

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  const loggingService = inject(LoggingService);
  loggingService.error(err);
});
